import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import IndexPage from 'flarum/forum/components/IndexPage';
import Separator from 'flarum/common/components/Separator';
import UserPage from 'flarum/forum/components/UserPage';

export default () => {
  extend(IndexPage.prototype, 'navItems', (items) => {
    if (app.forum.blomstraLinkAccessPortal() && app.forum.pk()) {
      items.add(
        'accessPortal',
        LinkButton.component(
          {
            icon: 'fas fa-key',
            href: app.route('blomstra-payments.access-portal'),
          },
          app.translator.trans('blomstra-payments.forum.nav.access_portal')
        ),
        75
      );
    } else if (app.forum.blomstraLinkAccessPortal()) {
      console.error('No publishable key set for blomstra/payments, access portal currently inaccessible.');
    }
  });

  extend(UserPage.prototype, 'navItems', function (items) {
    const user = this.user;

    if (app.forum.pk() && app.session.user === user) {
      items.add('separator-payments-subscriptions', <Separator />, -105);
      items.add(
        'paymentsSubscriptions',
        <LinkButton href={app.route('blomstra-payments.user-payments', { username: user.slug() })} icon="fas fa-store">
          {app.translator.trans('blomstra-payments.forum.nav.user_subscriptions')}
        </LinkButton>,
        -110
      );
    }
  });
};
